import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwDividerComponent } from './cdw-divider/cdw-divider.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule],
  declarations: [CdwDividerComponent],
  exports: [CdwDividerComponent],
})
export class CdwDividerModule {}
